import React from "react";

import Profile from "./components/Profile";

function App() {
  return <Profile />;
}

export default App;
